<template>
  <div class="shop_head">
    <head-top></head-top>

    <!-- logo and search -->
    <div class="center_top width_center_1200" v-show="center_top">
      <div class="shop_logo float_left">
        <router-link to="/">
          <img src="/images/logo.png" alt="迅貓先鋒" />
        </router-link>
      </div>
      <div v-show="showHead" class="shop_top_seach float_left">
        <div class="search_input">
          <input
            v-model="keyword"
            type="text"
            :placeholder="config && config.searchhotkey"
            @keyup.enter="search"
          />
          <svg-icon iconClass="search" @click="search" />
        </div>
        <div v-if="config" class="keywords">
          <span
            v-for="(item, index) in config.searchhotkeylist.split(',')"
            :key="index"
            @click="handleSearchKey(item)"
          >{{ item }}</span>
        </div>
      </div>
      <ul v-show="!showHead" class="user-nav float_left">
        <router-link to="/">
          <li>{{ lang.home }}</li>
        </router-link>
        <router-link to="/user/info">
          <li :class="{ 'cur': $route.path === '/user/info' }">{{ lang.account_setting }}</li>
        </router-link>
      </ul>
      <div
        v-if="isLogin"
        class="index_my_car"
      >
        <router-link to="/goods/cart">
          <svg-icon iconClass="cart" /> {{ lang.cart }}
          <div
            v-if="cartNum > 0"
            class="shop_car_dot"
          >{{ cartNum }}</div>
        </router-link>
      </div>
    </div>

    <!-- nav -->
    <div v-show="showHead" class="shop_top_nav">
      <div class="width_center_1200">
        <div
          v-if="show_nav"
          class="shop_top_nav_left"
          :class="{ 'cur' : subnav_show }"
          @mouseover="subnav_show?subnav:subnav=true"
          @mouseleave="subnav_show?subnav:subnav=false"
        >
          {{ lang.categories }}
          <i class="el-icon-caret-bottom" />
          <transition name="el-zoom-in-top">
            <leftBar :change_color="change_color" v-show="subnav"></leftBar>
          </transition>
        </div>
        <div class="shop_top_nav_right">
          <ul>
            <li :class="{ 'cur': $route.path === '/home/coffee' }">
              <router-link to="/home/coffee?type=2">{{ lang.coffee }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/goods/list' }">
              <router-link to="/goods/list">{{ lang.hotsale }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/goods/seckill' }">
              <router-link to="/goods/seckill">{{ lang.special_offer }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/card/list' }">
              <router-link to="/card/list">{{ lang.card_buy }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/home/machine' }">
              <router-link to="/home/machine">{{ lang.machine_location }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/points/index' }">
              <router-link to="/points/index">{{ lang.points_mall }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/about_us' }">
              <router-link to="/about_us">{{ lang.about_us }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/contact_us' }">
              <router-link to="/contact_us">{{ lang.contact_us }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftBar from '@/components/LeftBar/index'
import HeadTop from './Top.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    leftBar,
    HeadTop
  },
  props: {
    keyword: {
      type: String,
      default: undefined
    },
    show_nav: {
      type: Boolean,
      default: true
    },
    subnav_show: {
      type: Boolean,
      default: true
    },
    change_color: {
      type: Boolean,
      default: false
    },
    cart_change: {
      type: Number
    }
  },
  data() {
    return {
      subnav: true,
      cart_count: 0,
      center_top: true,
      industryList: [],
      name: ''
    }
  },
  computed: {
    lang() {
      return this.$t('public_head')
    },
    showHead() {
      return this.$route.meta.hideNav ? false : true
    },
    ...mapGetters(['isLogin', 'cartNum', 'config'])
  },
  watch: {
    subnav_show(val) {
      this.subnav = val
    },
    keyword(val) {
      this.name = val
    }
  },
  methods: {
    search() {
      if (this.$route.path !== '/goods/list') {
        this.$router.push(`/goods/list?keyword=${this.keyword}`)
      }
      this.$emit('search', this.keyword)
    },
    handleSearchKey(keyword) {
      if (this.$route.path !== '/goods/list') {
        this.$router.push(`/goods/list?keyword=${keyword}`)
      }
      this.$emit('search', keyword)
    }
  },
  created() {
    let _that = this
    this.subnav = this.subnav_show
    // 监听滚动条
    window.addEventListener(
      'scroll',
      () => {
        let topHeight = _that.$route.meta.hideNav ? 120 : 210
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
        if (scrollTop > topHeight) {
          this.center_top = false
        } else {
          this.center_top = true
        }
      },
      true
    )
  },
  mounted() {
    if (this.isLogin) {
      this.$store.dispatch('updateCart')
    }
  }
}
</script>

<style lang="scss" scoped>
.shop_head {
  z-index: 666;
  position: fixed;
  background: #fff;
  left: 0;
  right: 0;
}

.center_top:after {
  display: block;
  clear: both;
  content: '';
}

.shop_logo {
  margin: 28px 0;
  height: 68px;
  img {
    width: 182px;
    margin-top: 16px;
  }
}

.shop_top_nav {
  height: 40px;
  background: #ec9221;
  font-size: 14px;
  line-height: 40px;
  color: #fff;
  .shop_top_nav_left {
    text-align: center;
    float: left;
    width: 140px;
    // background: #d78722;
    box-sizing: border-box;
    position: relative;
    &.cur,
    &:hover {
      background: #d78722;
    }
    i {
      padding-left: 14px;
    }
  }
  .shop_top_nav_right {
    float: left;
    ul li {
      float: left;
      &.cur {
        background: #d78722;
      }
    }
    ul li a {
      line-height: 40px;
      width: 132px;
      text-align: center;
      color: #fff;
      display: block;
    }
    ul li a:hover {
      background: #d78722;
    }
  }
}

.shop_top_seach {
  margin-top: 36px;
  margin-left: 224px;
  .search_input {
    width: 377px;
    border: 1px solid #ec9221;
    box-sizing: border-box;
    font-size: 12px;
    display: flex;
    align-items: center;
    border-radius: 12px;
    padding: 3px 15px;
    input {
      width: 100%;
      height: 30px;
      outline: 0;
      border: 0;
      font-size: 14px;
      color: #4f4f4f;
    }
    .svg-icon {
      cursor: pointer;
    }
  }
  .keywords {
    padding-top: 4px;
    span {
      cursor: pointer;
      color: #aaaaaa;
      font-size: 12px;
      margin-left: 12px;
    }
  }
}

.index_my_car {
  float: right;
  width: 119px;
  height: 38px;
  border: 1px solid #efefef;
  margin: 44px 0 0 30px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 38px;
  border-radius: 12px;
  color: #4f4f4f;
  border: 1px solid #ec9221;
  position: relative;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .svg-icon {
    width: 24px;
    height: 24px;
    margin: 0 18px 3px 0;
  }
  a:hover {
    color: #ec9221;
  }
  .shop_car_dot {
    position: absolute;
    top: 3px;
    left: 29px;
    text-align: center;
    line-height: 16px;
    background: #ff0000;
    min-width: 20px;
    font-size: 12px;
    color: #fff;
    border-radius: 10px;
  }
}

.user-nav {
  margin-left: 40px;
  li {
    position: relative;
    float: left;
    line-height: 124px;
    padding: 0 40px;
    font-size: 16px;
    color: #4f4f4f;
    cursor: pointer;
    &:hover,
    &.cur {
      &::after {
        content: ' ';
        position: absolute;
        left: 50%;
        bottom: 0;
        margin-left: -5px;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid #ec9221;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
      }
    }
  }
}
</style>